import { CollectionContactResponse, CollectionDetailResponse, CollectionQueueResponse, RenegotiateResponse, SendCollectionTemplateResponse, } from '@aeris/contracts';
import { clientTimeZone, request } from "./client.js";
export const fetchCollectionQueue = async (query, signal) => {
    const params = new URLSearchParams({
        filter: query.filter,
        timeZone: clientTimeZone(),
    });
    if (query.search !== undefined && query.search.trim().length > 0) {
        params.set('search', query.search.trim());
    }
    if (query.sort !== undefined)
        params.set('sort', query.sort);
    if (query.page !== undefined)
        params.set('page', String(query.page));
    if (query.pageSize !== undefined) {
        params.set('pageSize', String(query.pageSize));
    }
    return CollectionQueueResponse.parse(await request(`/api/v1/finance/collections?${params.toString()}`, {
        ...(signal ? { signal } : {}),
    }));
};
export const fetchCollectionDetail = async (partyId, signal) => CollectionDetailResponse.parse(await request(`/api/v1/finance/collections/${encodeURIComponent(partyId)}?timeZone=${encodeURIComponent(clientTimeZone())}`, { ...(signal ? { signal } : {}) }));
export const recordCollectionContact = async (partyId, input) => CollectionContactResponse.parse(await request(`/api/v1/finance/collections/${encodeURIComponent(partyId)}/contacts`, { method: 'POST', body: input }));
export const renegotiateEntries = async (partyId, input) => RenegotiateResponse.parse(await request(`/api/v1/finance/collections/${encodeURIComponent(partyId)}/renegotiations`, { method: 'POST', body: input }));
export const sendCollectionTemplate = async (partyId, input) => SendCollectionTemplateResponse.parse(await request(`/api/v1/finance/collections/${encodeURIComponent(partyId)}/messages/template`, { method: 'POST', body: input }));
//# sourceMappingURL=collections.js.map